<div class="title-cont" *ngIf="showHeader">
  <div class="title">{{ title }}</div>
  <div class="header-actions">
    <button
      *ngIf="sortEnabled"
      type="button"
      class="sort-button"
      [title]="'global.reorder_skills' | translate"
      (click)="onSortClicked(); $event.stopPropagation()"
      [attr.aria-label]="'global.reorder_skills' | translate"
    >
      <img src="/assets/icons/sort-icon.svg" alt="" />
    </button>
    <div class="edit-button" *ngIf="formArray.length > 0 && editButton && !cvSharing" (click)="edit()">
      <img src="/assets/icons/edit-icon.svg" alt="" />{{ 'global.edit' | translate }}
    </div>
  </div>
</div>
<div
  class="skills-cont"
  *ngIf="formArray && formArray.length > 0"
  cdkDropList
  [cdkDropListDisabled]="!reordering"
  (cdkDropListDropped)="drop($event)"
>
  <div
    class="skill-row"
    [class.grid]="control === 'education' || control === 'job' || control === 'languages'"
    [class.reorder-active]="reordering"
    [class.separator-after]="separatorAfterIndex >= 0 && i === separatorAfterIndex"
    *ngFor="let skill of displayedSkills; let i = index"
    cdkDrag
    [cdkDragDisabled]="!reordering"
  >
    <span *ngIf="reordering" class="drag-handle" cdkDragHandle aria-hidden="true">
      <img src="/assets/icons/sort-icon.svg" alt="" />
    </span>
    <ng-container
      *ngIf="
        control === 'soft_skills' ||
        control === 'professional_skills' ||
        control === 'it_skills' ||
        control === 'task_skills' ||
        control === 'tasks_skills' ||
        control === 'knowledge_skills'
      "
    >
      <span class="skill-name">{{ skill.skill_name }}</span>
      <div class="skill-actions">
        <lib-stars-rate
          [index]="i"
          [starsRate]="skill.rating"
          [titlesDesc]="'skill_desc_level'"
          [readOnly]="blockStarClick || cvSharing"
          [disableStarTooltips]="blockStarClick || cvSharing"
          [matTooltip]="
            (blockStarClick || cvSharing) && skill.rating
              ? ('global.skill_desc_level_' + skill.rating | translate)
              : null
          "
          [matTooltipPosition]="'above'"
          (changeLevel)="starClicked($event)"
        ></lib-stars-rate>
        <button
          *ngIf="inlineEditing"
          type="button"
          class="delete-btn"
          (click)="onDeleteSkill(i)"
          [attr.aria-label]="'global.delete_skill_confirm' | translate"
        >
          <img src="/assets/icons/delete-icon.svg" alt="" />
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="control === 'languages'">
      <div class="language-name">{{ skill.skill_name }}</div>

      <div class="language-ratings" *ngIf="!skill.is_native">
        <div class="language-rating-groups">
          <div class="language-rating-group">
            <span class="rating-label">{{ 'global.written' | translate }}</span>
            <lib-stars-rate
              [index]="i"
              [starsRate]="skill.rating_written"
              [titlesDesc]="'skill_desc_level'"
              [readOnly]="blockStarClick || cvSharing"
              [disableStarTooltips]="blockStarClick || cvSharing"
              [matTooltip]="
                (blockStarClick || cvSharing) && skill.rating_written
                  ? ('global.skill_desc_level_' + skill.rating_written | translate)
                  : null
              "
              [matTooltipPosition]="'above'"
              (changeLevel)="starClickedWritten($event)"
            ></lib-stars-rate>
          </div>
          <div class="language-rating-group">
            <span class="rating-label">{{ 'global.speak' | translate }}</span>
            <lib-stars-rate
              [index]="i"
              [starsRate]="skill.rating"
              [titlesDesc]="'skill_desc_level'"
              [readOnly]="blockStarClick || cvSharing"
              [disableStarTooltips]="blockStarClick || cvSharing"
              [matTooltip]="
                (blockStarClick || cvSharing) && skill.rating
                  ? ('global.skill_desc_level_' + skill.rating | translate)
                  : null
              "
              [matTooltipPosition]="'above'"
              (changeLevel)="starClicked($event)"
            ></lib-stars-rate>
          </div>
        </div>
        <button
          *ngIf="inlineEditing"
          type="button"
          class="delete-btn"
          (click)="onDeleteSkill(i)"
          [attr.aria-label]="'global.delete_skill_confirm' | translate"
        >
          <img src="/assets/icons/delete-icon.svg" alt="" />
        </button>
      </div>
      <div class="skill-actions" *ngIf="skill.is_native">
        <div class="language-native">
          {{ 'global.native' | translate }}
        </div>
        <button
          *ngIf="inlineEditing"
          type="button"
          class="delete-btn"
          (click)="onDeleteSkill(i)"
          [attr.aria-label]="'global.delete_skill_confirm' | translate"
        >
          <img src="/assets/icons/delete-icon.svg" alt="" />
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="control === 'education'">
      <div class="left-items">
        <div>{{ skill.school_name }}</div>
        <span>{{ skill.education_name }}</span>
      </div>
      <div class="item-level">{{ getEducationLevelLabelKey(skill.education_level) | translate }}</div>
      <div class="item-years">
        <ng-container *ngIf="skill.start_date; else dash"
          >{{ skill.start_date | monthYear }} - {{ skill.end_date | monthYear }}</ng-container
        >
      </div>
    </ng-container>

    <ng-container *ngIf="control === 'work_history'">
      <div class="work-history-header">
        <div class="left-items work-history">
          <div class="position-name">{{ skill.position_name }}</div>
          <span class="company-name">{{ skill.company_name }}</span>
        </div>
        <div class="item-years">
          <ng-container *ngIf="skill.start_date; else dash"
            >{{ skill.start_date | monthYear
            }}<ng-container *ngIf="skill.end_date"> - {{ skill.end_date | monthYear }}</ng-container></ng-container
          >
        </div>
      </div>
      <div class="work-history-description" *ngIf="skill.job_description">
        {{ skill.job_description }}
      </div>
    </ng-container>
  </div>

  <ng-template #dash>-</ng-template>

  <div class="overflow-actions" *ngIf="overflowCount > 0 && !reordering">
    <button
      *ngIf="!showAll"
      type="button"
      class="show-more-btn"
      (click)="toggleShowAll()"
      [attr.aria-label]="'global.show_more' | translate"
    >
      +{{ overflowCount }} {{ 'global.skills' | translate | lowercase }}
    </button>
    <button
      *ngIf="showAll"
      type="button"
      class="show-less-btn"
      (click)="toggleShowAll()"
      [attr.aria-label]="'global.show_less' | translate"
    >
      <img src="/assets/icons/icon-down-b.svg" alt="" />
    </button>
    <img
      class="info-icon"
      src="/assets/icons/i-icon.svg"
      alt=""
      [matTooltip]="'global.reorder_skills_tooltip' | translate"
      matTooltipPosition="above"
    />
  </div>
</div>

<div class="info-cont" *ngIf="(!formArray || formArray.length === 0) && editButton && !cvSharing">
  <h3>{{ infoTxt }}</h3>
  <div class="button-cont">
    <button type="text" class="btn w-lg h-lg add-button" [disabled]="blockGoToEditionBtn" (click)="edit()">
      {{ buttonTxt }}
    </button>
    <div *ngIf="additionalBtnInfo && blockGoToEditionBtn" class="additional-btn-info">
      {{ additionalBtnInfo }}
    </div>
  </div>
</div>
<div class="info-cont cv-sharing" *ngIf="cvSharing && formArray.length === 0">
  <h3>{{ 'global.skill_to_be_filled' | translate }}</h3>
</div>
